import { createFileRoute, notFound } from "@tanstack/react-router";
import { DiscoverSeeMoreTemplate } from "~/features/discover/DiscoverSeeMoreTemplate";
import {
  DISCOVER_SEE_MORE_SECTIONS,
  type DiscoverSeeMoreSection,
} from "~/features/discover/types";

const isSeeMoreSection = (value: string): value is DiscoverSeeMoreSection =>
  (DISCOVER_SEE_MORE_SECTIONS as readonly string[]).includes(value);

const DiscoverSeeMorePage = () => {
  const section = Route.useRouteContext({ select: (c) => c.section });
  return <DiscoverSeeMoreTemplate section={section} />;
};

// loader でのプリフェッチはしない（取得は Template のフックで 1 ページずつ行う）
export const Route = createFileRoute(
  "/_authenticated/discover/section/$section",
)({
  beforeLoad: ({ params }) => {
    if (!isSeeMoreSection(params.section)) throw notFound();
    return { section: params.section };
  },
  component: DiscoverSeeMorePage,
});
